<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
html {
  background-color: #FFCE6D;
}

#program .html-entrance {
  color: black;
  text-decoration: underline;
  font-family: "Transcript Pro";
}

#program .html-entrance:hover {
  text-decoration: none;
}

#interpret .editor-content a,
#interpretEdit .ql-editor a {
  color: #FFCE6D !important;
}

#interpret .editor-content a:hover,
#interpretEdit .ql-editor a:hover {
  color: #FFCE6D !important;
  text-decoration: underline;
}

/* =========================
   Transcript Pro (Bold)
   ========================= */
@font-face {
  font-family: "Transcript Pro";
  src: url("~@/assets/Transcript_Pro_ono_Bold_4.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

/* =========================
   Transcript Mono (Regular)
   ========================= */
@font-face {
  font-family: "Transcript Mono";
  src: url("~@/assets/Transcript Pro Mono Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

/* =========================
   Transcript Pro Mono Regular (BOLD font file!)
   Pozn.: název nechávám, ale weight musí být 700,
   jinak Safari při font-weight:700 spadne do fallbacku.
   ========================= */
@font-face {
  font-family: "Transcript Pro Mono Regular";
  src: url("~@/assets/Transcript Pro Mono Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

/* =========================
   MinionPro Regular
   OTF Safari umí, ale přidáme format + display.
   ========================= */
@font-face {
  font-family: "MinioPro Regular";
  src: url("~@/assets/MinionPro-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

</style>
